import { useId } from 'react'
import styles from './Switch.module.css'

interface Props {
  checked: boolean
  onChange: (checked: boolean) => void
  label?: string
  note?: string
  disabled?: boolean
  /** Имя для читалки, когда подписи рядом нет — как в строке таблицы. */
  ariaLabel?: string | undefined
  /**
   * Переключатель в рамке поля: подпись слева, ручка справа.
   *
   * Так он нарисован в диалоге автовывода (Auto-Withdrawals 4:44343,
   * блок 544x48 с фоном и рамкой) — в один ряд с полями над ним.
   * Без рамки строка выпадает из формы и читается как подпись
   * к предыдущему полю, а это переключатель, который решает,
   * работает правило вообще или нет.
   */
  boxed?: boolean
}

/**
 * Переключатель из макета.
 *
 * Внутри настоящий `<input type="checkbox">`, спрятанный визуально:
 * так работают клавиатура, экранные читалки и автозаполнение формы.
 * Нарисованный из div переключатель ничего этого не умеет, и человек
 * с клавиатуры не сможет включить автовывод.
 */
export function Switch({
  checked, onChange, label, note, disabled, ariaLabel, boxed,
}: Props) {
  const id = useId()
  const row = [styles.row]
  if (boxed) row.push(styles.boxed)
  if (disabled) row.push(styles.disabled)
  const track = [styles.track]
  if (checked) track.push(styles.on)

  return (
    <label className={row.join(' ')} htmlFor={id}>
      <input
        id={id}
        type="checkbox"
        className={styles.native}
        checked={checked}
        disabled={disabled}
        aria-label={label ? undefined : ariaLabel}
        onChange={(event) => onChange(event.target.checked)}
      />
      {/* В рамке подпись идёт ПЕРВОЙ: в макете ручка прижата к правому
          краю поля, как у полей ввода — значение справа. */}
      {boxed && (label || note) ? (
        <span className={styles.body}>
          {label ? <span className={styles.title}>{label}</span> : null}
          {note ? <span className={styles.note}>{note}</span> : null}
        </span>
      ) : null}

      <span className={track.join(' ')} aria-hidden="true">
        <span className={styles.knob} />
      </span>

      {!boxed && (label || note) ? (
        <span className={styles.body}>
          {label ? <span className={styles.title}>{label}</span> : null}
          {note ? <span className={styles.note}>{note}</span> : null}
        </span>
      ) : null}
    </label>
  )
}
